import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as AppActions from 'actions/app'
import * as NewsActions from 'actions/news'
import * as ExportActions from 'actions/export'
import * as DashboardActions from 'actions/dashboard'
import * as Actions from 'actions/ai'

export const initialState = fromJS({
  showDialog: false,
  loading: false,
  analysis: null,
  mode: 'automatic',
  autoDetectMode: false,
  prompt: '',
  additionalModes: []
})

export default handleActions({
  [Actions.setAiAnalysisOption]: (state, { payload: { key, value } }) => state.set(key, value),

  [combineActions(
    Actions.showAiAnalysisDialog,
    NewsActions.showAiAnalysisDialog
  )]: state => state.merge({
    showDialog: true,
    analysis: null
  }),
  [Actions.hideAiAnalysisDialog]: state => state.merge({
    showDialog: false,
    analysis: null
  }),

  [combineActions(
    Actions.aiAnalysisStart,
    NewsActions.newsAiAnalysisStart,
    DashboardActions.loadDrilldownNewsFeedAiAnalysisStart,
    DashboardActions.loadDashboardAutoSelectionNewsFeedAiAnalysisStart
  )]: state => state.set('loading', true),
  [combineActions(
    Actions.aiAnalysisSuccess,
    NewsActions.newsAiAnalysisSuccess,
    DashboardActions.loadDrilldownNewsFeedAiAnalysisSuccess,
    DashboardActions.loadDashboardAutoSelectionNewsFeedAiAnalysisSuccess
  )]: (state, { payload: { analysis } }) => state.merge({
    loading: false,
    analysis
  }),
  [combineActions(
    Actions.aiAnalysisError,
    NewsActions.newsAiAnalysisError,
    DashboardActions.loadDrilldownNewsFeedAiAnalysisError,
    DashboardActions.loadDashboardAutoSelectionNewsFeedAiAnalysisError
  )]: state => state.set('loading', false),

  [Actions.setAiAnalysis]: (state, { payload: analysis }) => state.set('analysis', analysis),

  [ExportActions.showExportDialog]: state => state.set('analysis', null),

  [AppActions.resetState]: () => initialState
}, initialState)
